import ChangeIsHoldDialog from './ChangeIsHoldDialog';

export default ChangeIsHoldDialog;
